import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";
import Vuelidate from "vuelidate";
import VCalendar from "v-calendar";
import Multiselect from "vue-multiselect";
import { firestorePlugin } from "vuefire";
import axios from "./services/api.service.js";
import "./assets/styles/nprogress.css";
import "./assets/styles/toolTip.css";
import VTooltip from "v-tooltip";
import "line-awesome/dist/line-awesome/css/line-awesome.min.css";

import 'bootstrap-vue/dist/bootstrap-vue.css'
import clickOutside from "./plugins/directives/click-outside.js";
Vue.directive("click-outside", clickOutside);
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VTooltip);

Vue.use(firestorePlugin);

// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
    componentPrefix: "vc" // Use <vc-calendar /> instead of <v-calendar />
    // ...other defaults
});

import { Plugin } from "vue-fragment";

Vue.use(Plugin);

Vue.use(Vuelidate);
Vue.component("multiselect", Multiselect);

axios.init(
    process.env.NODE_ENV === "development"
        ? "https://europe-west1-bpi-marrakech-34efc.cloudfunctions.net/"
        : "https://europe-west1-bpi-marrakech-34efc.cloudfunctions.net/"
);

const requireComponent = require.context(
    "./components",
    false,
    /Base[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName);

    const componentName = upperFirst(
        camelCase(fileName.replace(/^\.\/(.*)\.\w+$/, "$1"))
    );

    Vue.component(componentName, componentConfig.default || componentConfig);
});

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
